import { createSelector } from "reselect";
const selector = (state) => state.config;

export default createSelector([selector], (data) => data);